import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";
import { constants } from '../../../../../../../Helpers/Constants';

import ReminderActionsComponent from '../../../../../../Stakeholder/ReminderActionsComponent';
import EmptyState from '../../../../../../Common/EmptyState';
import { Trans } from 'react-i18next';
import { TabItem, Tabs } from '../../../../../../Common/DesignSystem/Tabs';
import Chip from '../../../../../../Common/DesignSystem/Chips';
import Button from '../../../../../../Common/DesignSystem/Button';
import colours from '../../../../../../Common/DesignSystem/Colours';

const VehicleRemindersTab = (props) => {
    const [remindersTab, setRemindersTab] = useState("All");
    const [allReminders, setAllReminders] = useState([]);
    const [activatedReminders, setActivatedReminders] = useState([]);
    const [upcomingReminders, setUpcomingReminders] = useState([]);
    const [completedReminders, setCompletedReminders] = useState([]);

    useEffect(() => {
        const { reminders: { active = [], completed = [] } } = props.vehicle_details;

        const allReminders = [...active, ...completed];

        const activated = allReminders.filter((reminder) => {
            return reminder.Active === 1 && (reminder.Remind_Date && moment().isAfter(moment(reminder.Remind_Date))) || (reminder.Remind_km && reminder.Remind_km < props.vehicle_details.vehicle.Odometer);
        });

        const upcoming = allReminders.filter((reminder) => {
            return reminder.Active === 1 && !(reminder.Remind_Date && moment().isAfter(moment(reminder.Remind_Date))) || (reminder.Remind_km && reminder.Remind_km < props.vehicle_details.vehicle.Odometer);
        });

        setAllReminders(allReminders);
        setCompletedReminders(completed);
        setUpcomingReminders(upcoming);
        setActivatedReminders(activated);
    }, [props.vehicle_details]);

    const renderTable = (tab) => {
        const tabs = {
            "All": allReminders,
            "Activated": activatedReminders,
            "Upcoming": upcomingReminders,
            "Completed": completedReminders
        }

        const remindersList = tabs[tab];

        if (remindersList.length <= 0) {
            return(
                <table className = "ds-table">
                    <tbody>
                        <tr>
                            <td colSpan = '7'>
                                <EmptyState image="Vehicle_Reminder_Empty.svg" text="No Reminders" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            )
        } else {
            return(
                <table className = "ds-table">
                    <thead>
                        <tr className = "table-header">
                            <th className="align-center"><Trans>Status</Trans></th>
                            <th className="align-left"><Trans>Type</Trans></th>
                            <th className="align-left"><Trans>Date Reminder</Trans></th>
                            <th className="align-left"><Trans>KM Reminder</Trans></th>
                            <th className="align-left"><Trans>Created By</Trans></th>
                            <th className="align-left"><Trans>Completed By</Trans></th>
                            <th className="align-center"><Trans>Actions</Trans></th>
                        </tr>
                    </thead>
                    <tbody>
                        {remindersList.map((reminders, index) => (
                            <tr className="ds-booking-row no-border" key={reminders.REMIND_ID} style={{cursor: 'initial', background: index % 2 == 0 ? 'white' : '#F4F6F8'}}>
                                <td className="align-center">
                                    <div className="blocked_status blue_box" style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                                        {reminders.Active == -2 ? (
                                            <Chip type="completed"/>
                                        ) :
                                            (reminders.Remind_Date && moment().isAfter(moment(reminders.Remind_Date))) || (reminders.Remind_km && reminders.Remind_km < props.vehicle_details.vehicle.Odometer) ? (
                                                <Chip custom={{backgroundColor: colours.accent.error_red, fontColor: 'white', label: "Activated"}}/>
                                            ) : (
                                                <Chip custom={{backgroundColor: "#265BFF", fontColor: 'white', label: "Upcoming"}}/>
                                            )
                                        }
                                    </div> 
                                </td>
                                <td className="align-left">
                                    {constants.reminder_options[reminders.Category]}
                                </td>
                                {reminders.Remind_Date ? (
                                    <td className="align-left">{moment(reminders.Remind_Date).format("MMM DD, YYYY")}</td>
                                ) : (
                                    <td className="align-left"><span className = "black-lightest"><Trans>N/A</Trans></span></td>
                                )}
                                {reminders.Remind_km ? (
                                    <td className="align-left">{new Intl.NumberFormat('en-CA').format(reminders.Remind_km)} KM</td>
                                ) : (
                                    <td className="align-left"><span className = "black-lightest">N/A</span></td>
                                )}
                                {reminders.scheduled_by ? (
                                    <td className="align-left">{reminders.scheduled_by.First_Name + ' ' + reminders.scheduled_by.Last_Name}</td>
                                ) : (
                                    <td className="align-left"><span className = "black-lightest">N/A</span></td>
                                )}
                                {reminders.Completed_By ? (
                                    <td className="align-left">{reminders.Completed_By}</td>
                                ) : (
                                    <td className="align-left"><span className = "black-lightest">N/A</span></td>
                                )}
                                <td className="align-center">
                                    {reminders.has_booking && props.userSession.user.has_booking_access && (
                                        <ReminderActionsComponent completed={reminders.Active == -2} match={props.match} history={props.history} id={reminders.REMIND_ID} V_ID={reminders.vehicle.V_ID}/>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )
        }
    }

    return(
        <div className="row expanded bkg-white-dark">
            <div className="columns large-12 medium-12 small-12" style={{padding: 0}}>
                <div className="ds-card">
                    <div className="border-bottom" style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'row', paddingBottom: 16}}>
                        <Tabs value={remindersTab} onChange={(e) => {setRemindersTab(e.currentTarget.dataset.id)}}>
                            <TabItem label="All"/>
                            <TabItem label="Activated"/>
                            <TabItem label="Upcoming"/>
                            <TabItem label="Completed"/>
                        </Tabs>
                        <Button label="Add Reminder" leading_ic="Reminder" onClick={()=>{props.history.push(props.match.url + '/vehiclereminder/' + props.match.params.v_id)}}/>
                    </div>
                    <div>
                        {renderTable(remindersTab)}
                    </div>
                    <div className = "clearfix"></div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings,
    data: store.data
})

export default connect(mapStateToProps)(VehicleRemindersTab)